<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.cinemaWebsite.priceTable.title") }}</h1>
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="7">
            <el-input
              :placeholder="$locale('cinemaWebsite.priceTable.plsInputName')"
              v-model="onSearch.name"
              @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow cinema-website " @click="filter_fn">{{
              $locale("global.search")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="ta-r" :span="10">
        <el-button class="egl-btn-yellow" @click="create_fn">{{ $locale("cinemaWebsite.custom.create") }}</el-button>
      </el-col>
    </el-row>
    <!-- table -->
    <el-table
      :data="tableData"
      class="egl-table list-table"
      stripe
    >
      <el-table-column
        class-name="tableRow1"
        :label="$locale('cinemaWebsite.priceTable.table.header.name')"
        prop="name"
        align="center"
        width="250"
      ></el-table-column>
      <el-table-column
        :label="$locale('cinemaWebsite.custom.table.header.sort')"
        prop="sort"
        align="center"
        width="250"
      ></el-table-column>
      <el-table-column
        class-name="tableRow1"
        :label="$locale('cinemaWebsite.custom.table.header.description')"
        prop="description"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$locale('cinemaWebsite.custom.table.header.price')"
        prop="price"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.price | currencyFormatter }}</div>
      </template>
      </el-table-column>
      <el-table-column align="center" width="160">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="showDetail(scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row.id, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      v-show="pageCount > 10"
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>
<script>
import { getPriceTableListService, deletePriceTableService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import { toThousands } from "@/utils/common";
export default {
  data() {
    return {
      onSearch: {
        name: "",
        page: 0,
        pageSize: 10,
      },
      pageCount: 0,
      tableData: [],
    };
  },
  created() {
    this.getPriceTableList();
  },
  methods: {
    getPriceTableList() {
      if(window.localStorage.getItem("cinemaId")) {
        getPriceTableListService({
          cinemaId: window.localStorage.getItem("cinemaId"),
          ...this.onSearch.name ? {
            name: this.onSearch.name
          } : {},
          page: this.onSearch.page,
          pageSize: 10,
        }).then(res => {
          /**
           * reponse structure
           * data {
           *  count {string}
           *  data {Array}
           * } | null
          */
          if (res.data && res.data.data.length > 0) {
            this.tableData = res.data.data;
          } else {
            this.tableData = [];
          }
          this.pageCount = res.data.count;
        });
      } else {
        console.log("no cinemaId");
      }
    },
    filter_fn() {
      this.onSearch.page = 0;
      this.getPriceTableList();
    },
    create_fn() {
      this.$router.push("/priceTable/create");
    },
    showDetail(id) {
      this.$router.push(`/priceTable/update/${id}`);
    },
    delete_fn(id, name) {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          deletePriceTableService({ id }).then(res => {
            if (!res.success) { return; }
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.getPriceTableList();
              }
            });
          });
        });
    },
    choosePage(page) {
      this.onSearch.page = page - 1;
      this.getPriceTableList();
    },
    priceFormatter(value) {
      return toThousands(value);
    }
  },
  components: {
    CommPagination
  }
};
</script>